import { render, staticRenderFns } from "./invoiceHis.vue?vue&type=template&id=6c331bef&scoped=true&"
import script from "./invoiceHis.vue?vue&type=script&lang=js&"
export * from "./invoiceHis.vue?vue&type=script&lang=js&"
import style0 from "./invoiceHis.vue?vue&type=style&index=0&id=6c331bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c331bef",
  null
  
)

export default component.exports